var supportsErrorCause = function supportsErrorCause() {
  var _Error;
  var cause = Symbol('');
  return ((_Error = new Error('', {
    cause: cause
  })) === null || _Error === void 0 ? void 0 : _Error.cause) === cause;
};

export { supportsErrorCause };
